import Swiper, { A11y, Navigation, Pagination } from 'swiper';
class mTileSlider extends HTMLDivElement {
    constructor() {
        super();
        this.swiper = {};
        this.sliderInitialised = false;
        this.nextButton = this.querySelector('.btn-next');
        this.prevButton = this.querySelector('.btn-prev');
        // bind this
        this.initSlider = this.initSlider.bind(this);
    }

    connectedCallback() {
        // init slider when it is visible
        this.initSliderOnVisibility();
    }

    initSlider() {
        if (!this.sliderInitialised) {
            this.swiper = new Swiper(this, {
                modules: [A11y, Navigation, Pagination],
                loop: false,
                navigation: {
                    nextEl: '.btn-next',
                    prevEl: '.btn-prev'
                },
                a11y: {
                    prevSlideMessage: this.dataset.a11ySlidePrev,
                    nextSlideMessage: this.dataset.a11ySlideNext
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                preventInteractionOnTransition: true,
                on: {
                    afterInit: () => {
                        if (this.nextButton) {
                            this.nextButton.addEventListener('click', (e2) => { this.goto(e2.currentTarget.classList.value); });
                        }
                        if (this.prevButton) {
                            this.prevButton.addEventListener('click', (e2) => { this.goto(e2.currentTarget.classList.value); });
                        }
                    }
                }
            });
            this.sliderInitialised = true;
            this.observer.unobserve(this);
        }
    }

    goto(destination) {
        if (destination.includes('next')) {
            this.swiper.slideNext();
        } else if (destination.includes('prev')) {
            this.swiper.slidePrev();
        }
    }

    initSliderOnVisibility() {
        var options = {
            threshold: 0.3
        };

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    this.initSlider();
                }
            });
        }, options);

        this.observer.observe(this);
    }
}

customElements.define('m-tile-slider', mTileSlider, {
    extends: 'div'
});
